import React, { useRef, useEffect, useState } from "react";
import Plotly from "plotly.js-dist";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Button } from "@mui/material";
import DownloadReportIcon from "./../../asset/download.svg";
import DisabledDownloadReportIcon from "./../../asset/disabledDownload.svg";
import { useStoreState } from "easy-peasy";
import footerLogo from "./../../asset/avient-logo.jpg";
import homeFooterLogo from "./../../asset/avient-horz-rgb.jpg";
import HomePage from "./../../asset/pdf-home-page.png";
import HomePageColorNow from "./../../asset/pdf-home-colornow.jpg";
import ColorPredictionToolImg from "./../../asset/Color-Prediction-Tool.png";

import Loader from "./loader";
import {
  plotlyGamutGraphTreaceData,
  calculateSizeOfGamut,
  getContrastColorFromRgb,
  resinMaterialDetails,
  removeHtmlEntitiesAndTags,
  sliceString,
  virginResinMaterialDetails,
  calculateDeltaE,
} from "./../../utils/graph-helper";
import {
  TOP_VIEW_LAYOUT,
  RED_GREEN_VIEW_LAYOUT,
  YELLOW_BLUE_VIEW_LAYOUT,
  CONFIG,
  RESET_THREE_D_VIEW_LAYOUT,
} from "./../../utils/graph-layouts";

const DownloadReport = () => {
  const [graphsCaptured, setGraphsCaptured] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  let downloadBtnDisabled = useStoreState((state) => state.downloadBtnDisabled);
  let requirements = useStoreState((state) => state.requirements);
  let inputColor = useStoreState((state) => state.inputColor);
  let evaluationResult = useStoreState((state) => state.evaluationResult);
  let selectedColorPoints = useStoreState((state) => state.downloadReport);
  const [isVisible, setIsVisible] = useState(true);
  const plotRef1 = useRef(null);
  const plotRef2 = useRef(null);
  const plotRef3 = useRef(null);
  const plotRef4 = useRef(null);

  let pageNumber = 1;

  const chartPageFooter = async (doc, gamutSizeObj) => {
    var resinDetails = resinMaterialDetails(requirements);
    console.log(requirements);
    var virginresinDetails = virginResinMaterialDetails(requirements);

    doc.setFont("helvetica", "bold"); // Set the font to Helvetica with bold style
    doc.setFontSize(12); // Set the font size for the footer
    doc.setTextColor("#555555");
    doc.text(
      15,
      doc.internal.pageSize.height - 30,
      "GAMUT ANALYSIS: RECYCLED & VIRGIN RESIN VIEW"
    );
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");

    doc.setFillColor("#7f7f7f");
    doc.rect(15, doc.internal.pageSize.height - 27.5, 6.5, 3.5, "F");
    doc.text(
      23,
      doc.internal.pageSize.height - 25,
      `Recycled Resin: ${resinDetails} | GamutVOL: ${gamutSizeObj.recyCledGamutSize}`
    );

    doc.setFillColor("#e5e5e5");
    doc.rect(15, doc.internal.pageSize.height - 22.5, 6.5, 3.5, "F");

    doc.text(
      23,
      doc.internal.pageSize.height - 20,
      `Virgin Resin: ${virginresinDetails} | GamutVOL: ${gamutSizeObj.virginGamutSize}`
    );
    doc.setTextColor("#8A8A8A");
    /* Footer Logo common part */
    await commonFooter(doc);
  };

  const commonFooter = async (doc) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(165); // Black color for text
    doc.text(
      12,
      doc.internal.pageSize.height - 6,
      `Avient Corporation                       ${pageNumber}`
    );
    doc.addImage(footerLogo, "JPEG", 250, 197, 33, 0);
    pageNumber = pageNumber + 1;
  };

  const pdfHomePage = async (doc) => {
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const imageWidth = pageWidth * 0.75;
    // Add the image to the PDF
    doc.addImage(HomePage, "PNG", 0, 0, imageWidth, pageHeight);
    doc.setFillColor(168, 168, 168); // Set fill color to light grey (R, G, B)
    const rectWidth = pageWidth * 0.6; // Set the width of the rectangle to 60% of the page width
    const rectHeight = 15; // Fixed height of 15 pixels
    const rectY = 70; // Center the rectangle vertically

    doc.rect(160, 70, rectWidth - 40, rectHeight, "F"); // Draw the filled rectang
    /* This rectangle height is dynamic according to the lines of the text */
    var resinDetails = resinMaterialDetails(requirements);
    //var tempString = '1mm 2% in 100% ECOPET (FRANCE PLASTIQUE) 1mm 2% in 100% ECOPET (FRANCE PLASTIQUE) ';
    const arrString = sliceString(resinDetails, 45);
    console.log(arrString);
    const secondRectHeight = 18 + arrString.length * 4;
    doc.rect(160, 86, rectWidth - 40, secondRectHeight, "F"); // Second rectangle

    doc.setFont("helvetica", "bold");

    doc.setTextColor(255); // Set text color to black (R, G, B)
    doc.setFontSize(25); // Set font size
    // Calculate the position to center the text inside the rectangle
    const textY = rectY + rectHeight / 2; // Center the text vertically
    // Add the text to the PDF with alignment options to center it
    doc.text("EVALUATION REPORT", 170, textY, { baseline: "middle" });

    doc.setFontSize(14); // Set font size
    const today = new Date();
    const day = today.getDate().toString().padStart(2, "0"); // Ensure two digits for day
    const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
    const month = (today.getMonth() + 1).toString().padStart(2, "0"); // Ensure two digits for month
    const formatted = `${day}-${month}-${year}`;
    doc.text(
      `G A M U T  A N A L Y S I S  ${formatted.split("").join(" ")}`,
      170,
      textY + 13,
      { baseline: "middle" }
    );
    doc.setFontSize(13); // Set font size
    let initialHeight = 23;
    arrString.forEach((element, index) => {
      doc.text(`${element.trim()}`, 170, textY + initialHeight, {
        baseline: "middle",
      });
      initialHeight = initialHeight + 5;
    });
    doc.setFont("helvetica", "normal");

    doc.setFontSize(15);
    doc.setTextColor(50); // Black color for text
    doc.setCharSpace(0.55);

    doc.addImage(ColorPredictionToolImg, "SVG", 207, 185, 72, 4, "", 0);

    // doc.text(`COLOR  PREDICTION  TOOL`, doc.internal.pageSize.height - 3, 188, {
    //   baseline: "middle",
    // });
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(165); // Black color for text
    doc.text(
      12,
      doc.internal.pageSize.height - 5,
      `Avient Corporation                       ${pageNumber}`
    );
    doc.addImage(HomePageColorNow, "JPEG", 205, 194, 42, 0, "", 1);
    doc.addImage(homeFooterLogo, "JPEG", 250, 195, 30, 0);
    pageNumber = pageNumber + 1;
  };

  const generatePDF = async () => {
    try {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Optional: Adds smooth scrolling animation
      });
      setLoading(true);
      setIsVisible(true);
      const doc = new jsPDF("landscape", "mm", "a4", {
        unit: "pt", // Use points as the unit
        format: [400, 250], // Custom rectangular page size (600x400 points)
      });
      /* PDF home page */
      await pdfHomePage(doc);

      let graphData = plotlyGamutGraphTreaceData(
        evaluationResult,
        selectedColorPoints["pointsVisible"]
      );
      // Create 3D View layout with optimized settings for PDF
      let threeDLayout = {...RESET_THREE_D_VIEW_LAYOUT};
      threeDLayout.width = 600; // Maximum resolution width for premium quality
      threeDLayout.height = 600; // Maximum resolution height for premium quality
      threeDLayout.margin = {
        r: 20,
        l: 20,
        b: 20,
        t: 20,
      };
      threeDLayout.scene = {
        ...threeDLayout.scene,
        aspectmode: 'data', // Use aspect ratios based on axis ranges defined in layout
        camera: {
          center: {
            x: 0,
            y: 0,
            z: 0,
          },
          eye: {
            x: -1.7,
            y: -1.7,
            z: 1.7,
          },
          up: {
            x: 0,
            y: 0,
            z: 1,
          },
        },
        xaxis: {
          ...threeDLayout.scene.xaxis,
          title: {
            text: "a*",
            font: { size: 11 }
          },
          tickmode: 'linear',
          tick0: -100,
          dtick: 20,
          tickfont: { size: 11 }
        },
        yaxis: {
          ...threeDLayout.scene.yaxis,
          title: {
            text: "b*",
            font: { size: 11 }
          },
          tickmode: 'linear',
          tick0: -100,
          dtick: 20,
          tickfont: { size: 11 }
        },
        zaxis: {
          ...threeDLayout.scene.zaxis,
          title: {
            text: "L*",
            font: { size: 11 }
          },
          tickmode: 'linear',
          tick0: 0,
          dtick: 20,
          tickfont: { size: 11 },
          showspikes: false,
          visible: true
        }
      };

      // Create Top View layout with grid for PDF
      const { annotations: topAnnotations, ...topLayoutWithoutAnnotations } = TOP_VIEW_LAYOUT;
      const { annotations: topSceneAnnotations, ...topSceneWithoutAnnotations } = TOP_VIEW_LAYOUT.scene;
      // Custom annotations for a* axis at the bottom
      const topViewXAxisAnnotations = [
        { showarrow: false, text: "-100", x: -100.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "-80", x: -80.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "-60", x: -60.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "-40", x: -40.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "-20", x: -20.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "0", x: 0.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "20", x: 20.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "40", x: 40.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "60", x: 60.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "80", x: 80.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "100", x: 100.0, y: -100.0, z: 0.0, yshift: -40, font: { size: 8 } },
        { showarrow: false, text: "a*", x: 0.0, y: -100.0, z: 0.0, yshift: -50, font: { size: 8 } },
      ];
      let topViewLayoutWithGrid = {
        ...topLayoutWithoutAnnotations,
        width: 550, // Maximum resolution size for premium quality
        height: 550, // Square aspect ratio with premium quality
        margin: {
          r: 20,
          l: 20,
          b: 40, // More bottom margin for axis labels
          t: 20,
        },
        scene: {
          ...topSceneWithoutAnnotations,
          aspectmode: 'cube',
          camera: {
            center: {
              x: 0,
              y: 0,
              z: 0,
            },
            eye: {
              x: 0,
              y: 0,
              z: 2.4,
            },
            up: {
              x: 0,
              y: 1,
              z: 0,
            },
          },
          // annotations: topViewXAxisAnnotations,
          xaxis: {
            ...TOP_VIEW_LAYOUT.scene.xaxis,
            title: {
              text: "a*",
              font: { size: 11 }
            },
            tickmode: 'linear',
            tick0: -100,
            dtick: 20,
            visible: true,
            showgrid: true,
            gridcolor: "rgb(200, 200, 200)",
            gridwidth: 1,
            showline: false,
            showticklabels: true,
            showaxeslabels: false,
            backgroundcolor: "rgb(255, 255, 255)",
            tickfont: { size: 11 }
          },
          yaxis: {
            ...TOP_VIEW_LAYOUT.scene.yaxis,
            title: {
              text: "b*",
              font: { size: 11 }
            },
            tickmode: 'linear',
            tick0: -100,
            dtick: 20,
            visible: true,
            showgrid: true,
            gridcolor: "rgb(200, 200, 200)",
            gridwidth: 1,
            showline: false,
            showticklabels: true,
            showaxeslabels: false,
            backgroundcolor: "rgb(255, 255, 255)",
            tickfont: { size: 11 }
          },
          zaxis: {
            ...TOP_VIEW_LAYOUT.scene.zaxis,
            tickmode: 'linear',
            tick0: 0,
            dtick: 20,
            visible: true,
            showgrid: true,
            gridcolor: "rgb(200, 200, 200)",
            gridwidth: 1,
            showline: false,
            showticklabels: false,
            showaxeslabels: false,
            backgroundcolor: "rgb(255, 255, 255)",
            tickfont: { size: 11 }
          },
        },
      };

      Plotly.newPlot(plotRef1.current, graphData, threeDLayout, CONFIG); // Using newPlot() for efficient updates
      Plotly.newPlot(plotRef2.current, graphData, topViewLayoutWithGrid, CONFIG); // Using newPlot() for efficient updates

      doc.addPage();
      doc.setTextColor(0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // Calculate page center for proper alignment (shared variables)
      const pageWidth1 = doc.internal.pageSize.width;
      const leftHalfCenter1 = pageWidth1 / 4; // Center of left half
      const rightHalfCenter1 = (pageWidth1 * 3) / 4; // Center of right half
      const graphWidth1 = 110;
      const graphHeight1 = 110;
      // Top view gets same display size as Red-Green view
      const topGraphWidth = 130;
      const topGraphHeight = 130;
      const textOffset1 = 10; // Move text left by this amount
      const graphOffset1 = 5; // Move graphs right by this amount (reduced to move graphs left)
      
      // 3D View: text positioned left, graph positioned right in left half
      const threeDTextX = leftHalfCenter1 - textOffset1;
      const threeDGraphX = leftHalfCenter1 - (graphWidth1 / 2) + graphOffset1;
      doc.text("3D View", threeDTextX, 10, { align: "center" });

      if (plotRef1.current) {
        const canvas = await html2canvas(plotRef1.current, {
          scale: 3.5, // High scale for much better resolution and image quality
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff', // White background instead of null
          removeContainer: false,
          imageTimeout: 0,
          logging: false,
          width: 600, // Match Plotly layout width
          height: 600, // Match Plotly layout height
          dpi: 300, // Add DPI setting for better print quality
        });
        const imageData = canvas.toDataURL("image/jpeg", 0.95); // Use JPEG with very high quality for excellent image clarity
        // const imageData = await Plotly.toImage(plotRef1.current, {
        //   format: "png",
        //   width: 900,
        //   height: 800,
        // });
        // Plotly.purge(plotRef1.current);
        doc.addImage(imageData, "JPEG", threeDGraphX, 15, graphWidth1, graphHeight1);
      }

      // Top View: text positioned left, graph positioned right in right half  
      const topTextX = rightHalfCenter1 - textOffset1;
      const topGraphX = rightHalfCenter1 - (130 / 2) + graphOffset1;
      doc.text("Top View", topTextX, 10, { align: "center" });
      if (plotRef2.current) {
        const canvas = await html2canvas(plotRef2.current, {
          scale: 3.5, // High scale for much better resolution and image quality
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff', // White background instead of null
          removeContainer: false,
          imageTimeout: 0,
          logging: false,
          width: 550, // Match Plotly layout width
          height: 550, // Match Plotly layout height
          dpi: 300, // Add DPI setting for better print quality
        });
        const imageData2 = canvas.toDataURL("image/jpeg", 0.95); // Use JPEG with very high quality for excellent image clarity
        // const imageData = await Plotly.toImage(plotRef2.current, {
        //   format: "png",
        //   width: 900,
        //   height: 900,
        // });
        // Plotly.purge(plotRef2.current);
        doc.addImage(imageData2, "JPEG", topGraphX, 15, 130, 130);
      }

      /* Call common code of gamut size */
      const gamutSize = {
        virginGamutSize: calculateSizeOfGamut(
          evaluationResult["gamut"]["virginResinGamut"]
        ),
        recyCledGamutSize: calculateSizeOfGamut(
          evaluationResult["gamut"]["recycleResinGamut"]
        ),
      };

      await chartPageFooter(doc, gamutSize);

      /* Code for second chart page */

      // Create Red-Green View layout with grid for PDF
      const { annotations: redGreenAnnotations, ...redGreenLayoutWithoutAnnotations } = RED_GREEN_VIEW_LAYOUT;
      const { annotations: redGreenSceneAnnotations, ...redGreenSceneWithoutAnnotations } = RED_GREEN_VIEW_LAYOUT.scene;
      let redGreenViewLayoutWithGrid = {
        ...redGreenLayoutWithoutAnnotations,
        width: 550, // Maximum resolution width for premium quality
        height: 580, // Maximum resolution height for premium quality
        margin: {
          r: 20,
          l: 40, // More left margin for axis labels
          b: 40, // More bottom margin for axis labels
          t: 20,
        },
        scene: {
          ...redGreenSceneWithoutAnnotations,
          aspectmode: 'data', // Use data-driven aspect ratios based on axis ranges
          camera: {
            center: {
              x: 0,
              y: 0,
              z: 0,
            },
            eye: {
              x: 0,
              y: -2.5,
              z: 0.1,
            },
            up: {
              x: 0,
              y: 0,
              z: 1,
            },
          },
          xaxis: {
            ...RED_GREEN_VIEW_LAYOUT.scene.xaxis,
            title: {
              text: "a*",
              font: { size: 11 }
            },
            tickmode: 'linear',
            tick0: -100,
            dtick: 20,
            visible: true,
            showgrid: true,
            gridcolor: "rgb(200, 200, 200)",
            gridwidth: 1,
            showline: false,
            showticklabels: true,
            showaxeslabels: false,
            backgroundcolor: "rgb(255, 255, 255)",
            tickfont: { size: 11 }
          },
          yaxis: {
            ...RED_GREEN_VIEW_LAYOUT.scene.yaxis,
            tickmode: 'linear',
            tick0: 0,
            dtick: 20,
            visible: true,
            showgrid: true,
            gridcolor: "rgb(200, 200, 200)",
            gridwidth: 1,
            showline: false,
            showticklabels: false,
            showaxeslabels: false,
            backgroundcolor: "rgb(255, 255, 255)",
            tickfont: { size: 11 }
          },
          zaxis: {
            ...RED_GREEN_VIEW_LAYOUT.scene.zaxis,
            title: {
              text: "L*",
              font: { size: 11 }
            },
            tickmode: 'linear',
            tick0: 0,
            dtick: 20,
            visible: true,
            showgrid: true,
            gridcolor: "rgb(200, 200, 200)",
            gridwidth: 1,
            showline: false,
            showticklabels: true,
            showaxeslabels: false,
            backgroundcolor: "rgb(255, 255, 255)",
            tickfont: { size: 11 }
          },
        },
      };

      Plotly.newPlot(
        plotRef3.current,
        graphData,
        redGreenViewLayoutWithGrid,
        CONFIG
      ); // Using newPlot() for efficient updates
      // Create Yellow-Blue View layout with grid for PDF
      const { annotations: yellowBlueAnnotations, ...yellowBlueLayoutWithoutAnnotations } = YELLOW_BLUE_VIEW_LAYOUT;
      const { annotations: yellowBlueSceneAnnotations, ...yellowBlueSceneWithoutAnnotations } = YELLOW_BLUE_VIEW_LAYOUT.scene;
      let yellowBlueViewLayoutWithGrid = {
        ...yellowBlueLayoutWithoutAnnotations,
        width: 550, // Maximum resolution width for premium quality
        height: 580, // Maximum resolution height for premium quality
        margin: {
          r: 30, // Reduced right margin 
          l: 20,
          b: 40, // More bottom margin for axis labels
          t: 20,
        },
        scene: {
          ...yellowBlueSceneWithoutAnnotations,
          aspectmode: 'data', // Use data-driven aspect ratios based on axis ranges
          camera: {
            center: {
              x: 0,
              y: 0,
              z: 0,
            },
            eye: {
              x: 2.6,
              y: 0,
              z: 0.1,
            },
            up: {
              x: 0,
              y: 0,
              z: 1,
            },
          },
          xaxis: {
            ...YELLOW_BLUE_VIEW_LAYOUT.scene.xaxis,
            tickmode: 'linear',
            tick0: 0,
            dtick: 20,
            visible: true,
            showgrid: true,
            gridcolor: "rgb(200, 200, 200)",
            gridwidth: 1,
            showline: false,
            showticklabels: false,
            showaxeslabels: false,
            backgroundcolor: "rgb(255, 255, 255)",
            tickfont: { size: 11 }
          },
          yaxis: {
            ...YELLOW_BLUE_VIEW_LAYOUT.scene.yaxis,
            title: {
              text: "b*",
              font: { size: 11 }
            },
            tickmode: 'linear',
            tick0: -100,
            dtick: 20,
            visible: true,
            showgrid: true,
            gridcolor: "rgb(200, 200, 200)",
            gridwidth: 1,
            showline: false,
            showticklabels: true,
            showaxeslabels: false,
            backgroundcolor: "rgb(255, 255, 255)",
            tickfont: { size: 11 }
          },
          zaxis: {
            ...YELLOW_BLUE_VIEW_LAYOUT.scene.zaxis,
            title: {
              text: "L*",
              font: { size: 11 }
            },
            tickmode: 'linear',
            tick0: -100,
            dtick: 20,
            visible: true,
            showgrid: true,
            gridcolor: "rgb(200, 200, 200)",
            gridwidth: 1,
            showline: false,
            showticklabels: true,
            showaxeslabels: false,
            backgroundcolor: "rgb(255, 255, 255)",
            tickfont: { size: 11 }
          },
        },
      };

      Plotly.newPlot(
        plotRef4.current,
        graphData,
        yellowBlueViewLayoutWithGrid,
        CONFIG
      ); // Using react() for efficient updates

      doc.addPage();
      doc.setTextColor(0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // Adjust positioning: move text left and graphs right
      const pageWidth = doc.internal.pageSize.width;
      const graphWidth = 130;
      const graphHeight = 130;
      const textOffset = 10; // Move text left by this amount
      const graphOffset = 5; // Move graphs right by this amount (reduced to move graphs left)
      
      // Red-Green View: text positioned left, graph positioned right in left half
      const leftHalfCenter = pageWidth / 4;
      const redGreenTextX = leftHalfCenter - textOffset;
      const redGreenGraphX = leftHalfCenter - (graphWidth / 2) + graphOffset;
      doc.text("Red-Green View", redGreenTextX, 10, { align: "center" });

      if (plotRef3.current) {
        const canvas = await html2canvas(plotRef3.current, {
          scale: 3.5, // High scale for much better resolution and image quality
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff', // White background instead of null
          removeContainer: false,
          imageTimeout: 0,
          logging: false,
          width: 550, // Match Plotly layout width
          height: 580, // Match Plotly layout height
          dpi: 300, // Add DPI setting for better print quality
        });
        const imageData = canvas.toDataURL("image/jpeg", 0.95); // Use JPEG with very high quality for excellent image clarity
        // const imageData = await Plotly.toImage(plotRef3.current, {
        //   format: "png",
        //   width: 900,
        //   height: 800,
        // });
        // Plotly.purge(plotRef3.current);
        doc.addImage(imageData, "JPEG", redGreenGraphX, 15, graphWidth, graphHeight);
      }

      // Yellow-Blue View: text positioned left, graph positioned right in right half
      const rightHalfCenter = (pageWidth * 3) / 4;
      const yellowBlueTextX = rightHalfCenter - textOffset;
      const yellowBlueGraphX = rightHalfCenter - (graphWidth / 2) + graphOffset;
      doc.text("Yellow-Blue View", yellowBlueTextX, 10, { align: "center" });
      if (plotRef4.current) {
        const canvas = await html2canvas(plotRef4.current, {
          scale: 3.5, // High scale for much better resolution and image quality
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff', // White background instead of null
          removeContainer: false,
          imageTimeout: 0,
          logging: false,
          width: 550, // Match Plotly layout width
          height: 580, // Match Plotly layout height
          dpi: 300, // Add DPI setting for better print quality
        });
        const imageData = canvas.toDataURL("image/jpeg", 0.95); // Use JPEG with very high quality for excellent image clarity
        // const imageData = await Plotly.toImage(plotRef4.current, {
        //   format: "png",
        //   width: 900,
        //   height: 800,
        // });
        // Plotly.purge(plotRef4.current);
        doc.addImage(imageData, "JPEG", yellowBlueGraphX, 15, graphWidth, graphHeight);
      }

      await chartPageFooter(doc, gamutSize);
      /* Code for Result page */

      let startIndex = 0;
      let endIndex = 30;
      let batchData = [];

      /* Logic for filter doable true count */
      const doableResult = [];
      const notDoableResult = [];
      let finalResult = [];
      console.log("before target coloer");

      finalResult["target_color"] = evaluationResult["target_color"].map(
        (color, index) => {
          color = {
            ...color,
            name: removeHtmlEntitiesAndTags(
              inputColor["uploadedColorArray"][index]?.name
            ),
          };
          return color;
        }
      );

      finalResult["target_color"] = finalResult["target_color"].filter(
        (color, index) => {
          if (
            selectedColorPoints["pointsVisible"][index] ||
            selectedColorPoints["pointsVisible"][0] === "All"
          ) {
            if (color.doable === true) {
              doableResult.push(color);
            } else {
              notDoableResult.push(color);
            }
            return color;
          }
        }
      );

      const targetColorLen = finalResult["target_color"].length;
      let reminder = 0;
      if (targetColorLen > 30) {
        reminder = targetColorLen / 30;
      } else if (targetColorLen > 0) {
        reminder = 1;
      }
      var resinDetails = resinMaterialDetails(requirements);
      /* Logic for batch of 30 records of pdf page */

      console.log("before the reminder and i value");
      console.log(reminder);
      for (let i = 0; i < reminder; i++) {
        //pageNo = pageNo +1;
        batchData = finalResult["target_color"].slice(startIndex, endIndex);
        await resultPage(doc, batchData, {
          targetColorLen: targetColorLen,
          achievableCount: doableResult.length,
          resinDetails: resinDetails,
        });
        startIndex = endIndex;
        endIndex = endIndex + 30;
      }
      /* Logic for iteration of colorMatrix page */
      const notDoableCount = targetColorLen - doableResult?.length;
      let iteration = 1;

      if (notDoableCount / 3 > 1) {
        iteration = notDoableCount / 3;
      }

      if (notDoableCount > 0) {
        startIndex = 0;
        endIndex = 3;
        for (
          let colorIterator = 0;
          colorIterator < iteration;
          colorIterator++
        ) {
          const notDoableBatchData = notDoableResult.slice(
            startIndex,
            endIndex
          );
          await colorMatrixPage(doc, notDoableBatchData);
          startIndex = endIndex;
          endIndex = endIndex + 3;
        }
      }
      doc.save("report.pdf");
      setGraphsCaptured(true);
      setLoading(false);
      setIsVisible(false);
    } catch (error) {
      setLoading(false);
      console.log("Error while downloading the report");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const resultPage = async (doc, batchData, countDetails) => {
    doc.addPage();
    doc.setCharSpace(0);
    const startYY = 25;
    const rowHeight = 9.5; // Space between rows
    console.log(doc.getFontList());
    let firstSectionLength = 0;
    let secondSectionLength = 0;

    if (batchData.length > 15) {
      firstSectionLength = 15;
      secondSectionLength = batchData.length - 15;
    } else {
      firstSectionLength = batchData.length;
      secondSectionLength = 0;
    }

    for (let i = 0; i < batchData.length && i < firstSectionLength; i++) {
      let currentY = startYY + i * rowHeight;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9); // Set the font size for the footer
      if (batchData[i]["doable"] === true) {
        doc.setTextColor(14, 201, 92); // Green color
        doc.text("OK", 10, currentY);
      } else {
        doc.setTextColor(222, 16, 26); // Red color
        doc.text("NOK", 10, currentY);
      }

      doc.setTextColor(50, 50, 50);
      // Set the fill color for the first rectangle (blue)
      doc.setFillColor(
        batchData[i]["RGB"][0],
        batchData[i]["RGB"][1],
        batchData[i]["RGB"][2]
      );
      // Draw the first filled rectangle
      doc.rect(28, currentY - 4, 5, 5, "F");
      // Add the first unique text ("NE54400466")
      doc.setFont("helvetica", "normal");

      /* Get below value from the LAB points from session of state */
      console.log("Before batch data name");

      // Dynamic name selection here
      let batchName = batchData[i]["name"]
        ? batchData[i]["name"].substring(0, 65)
        : "NA";
      //let batchName = 'NEQUE-PORRO-QUISQUAM-EST-QUI-DOLOREM_IPSUM-QUIA-DOLORSIT-AMETeeeeeeee';
      let arrString = sliceString(batchName, 35);

      let yPosition = currentY;
      arrString.forEach((element) => {
        doc.text(element.trim(), 36, yPosition);
        yPosition = yPosition + 3;
      });
      if (batchData[i]["doable"] === false) {
        // Set the fill color for the second rectangle (light blue)
        doc.setFillColor(
          batchData[i]["RGB_of_9_colors"][0][0],
          batchData[i]["RGB_of_9_colors"][0][1],
          batchData[i]["RGB_of_9_colors"][0][2]
        );
        // Draw the second filled rectangle
        doc.rect(112, currentY - 4, 5, 5, "F");
        // Add the second text ("Nearest")
        doc.text(
          `${batchData[i]["delta_values"]["dE_star"].toFixed(2)}`,
          135,
          currentY
        );
      }
    }

    /* code for adding the line in center of page */
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const startX = pageWidth / 2; // Center X-coordinate
    const startY = 0; // Starting from the top edge
    const endX = pageWidth / 2; // Center X-coordinate
    const endY = pageHeight; // Ending at the bottom edge

    doc.setDrawColor(200, 200, 200); // RGB for light grey
    // Draw the vertical line
    doc.setLineWidth(0.02);
    doc.line(startX, startY + 10, endX, endY - 50);
    /*  Code for adding the rectangle on the page - right side */
    /* Second Page header */
    for (let i = 0, j = 15; i < secondSectionLength; i++, j++) {
      const currentY = startYY + i * rowHeight;
      // Add the first text ("NOK")
      doc.setFont("helvetica", "bold");
      // code for dynamic color code picker

      if (batchData[j]["doable"] === true) {
        doc.setTextColor(14, 201, 92); // Green color
        doc.text("OK", endX + 10, currentY);
      } else {
        doc.setTextColor(222, 16, 26); // Red color
        doc.text("NOK", endX + 10, currentY);
      }
      doc.setFont("helvetica", "normal");
      // Set the fill color for the first rectangle (blue)
      doc.setTextColor(50, 50, 50);
      // Set the fill color for the first rectangle (blue)
      doc.setFillColor(
        batchData[j]["RGB"][0],
        batchData[j]["RGB"][1],
        batchData[j]["RGB"][2]
      );
      // Draw the first filled rectangle
      doc.rect(endX + 30, currentY - 4, 5, 5, "F");
      // Add the first unique text ("NE54400466")

      let leftBatchName = batchData[j]["name"]
        ? batchData[j]["name"].substring(0, 65)
        : "NA";
      //let leftBatchName = 'NEQUE-PORRO-QUISQUAM-EST-QUI-DOLOREM_IPSUM-QUIA-DOLORSIT-AMETeeeeeeee';
      let leftArrString = sliceString(leftBatchName, 35);
      let yPosition = currentY;
      leftArrString.forEach((element) => {
        doc.text(element.trim(), endX + 38, yPosition);
        yPosition = yPosition + 3;
      });

      if (batchData[j]["doable"] === false) {
        doc.setFillColor(
          batchData[j]["RGB_of_9_colors"][0][0],
          batchData[j]["RGB_of_9_colors"][0][1],
          batchData[j]["RGB_of_9_colors"][0][2]
        );
        // Draw the second filled rectangle
        doc.rect(endX + 110, currentY - 4, 5, 5, "F");
        // Add the second text ("Nearest")
        doc.text(
          `${batchData[j]["delta_values"]["dE_star"].toFixed(2)}`,
          endX + 132,
          currentY
        );
      }
    }

    /* Add header of the result page */
    await resultPageHeader(doc, secondSectionLength);
    await resutlFooter(doc, countDetails);
    await commonFooter(doc);
  };

  const resultPageHeader = async (doc, secondSectionLength = 0) => {
    doc.setLineWidth(0.02); // Optional: Set the width of the line
    doc.setDrawColor(100, 100, 100); // black color (R, G, B)
    doc.line(3, 14, 143, 14); // Coordinates: (x1, y1, x2, y2)
    /* Result page header First section header */
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0); // black     4
    doc.setTextColor("#555555");
    doc.setFontSize(9); // Set the font size for the footer
    doc.text("RESULT", 10, 10);
    doc.text("TARGET COLOR", 28, 10);
    doc.text("NEAREST", 112, 10);
    doc.text("DE*", 135, 10);

    if (secondSectionLength > 0) {
      /* Result page header Second section header */
      doc.text("RESULT", 158, 10);
      doc.text("TARGET COLOR", 178, 10);
      doc.text("NEAREST", 258, 10);
      doc.text("DE*", 280, 10);
      doc.setLineWidth(0.02);
      doc.line(155, 14, 290, 14); // Line from middle to right (10mm margin from right edge)
    }
  };

  const colorMatrixPage = async (doc, notDoableResult) => {
    doc.setCharSpace(0.1);
    doc.addPage();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    // Define the size of the matrix cells
    const cellWidth = 14; // width of each cell
    const cellHeight = 14; // height of each cell
    const padding = 0; // padding between cells
    const matrixSpacing = 20; // space between matrices
    const numberOfMatrices = 3; // number of matrices per page
    const countOfNotDoable = notDoableResult.length;
    // Starting X position for the matrices
    const startX = (pageWidth - (cellWidth * 3 + padding * 2)) / 2;
    // Calculate starting Y position to center the matrices vertically
    const startY =
      (pageHeight -
        (cellHeight * 3 * numberOfMatrices +
          padding * (numberOfMatrices - 1) +
          matrixSpacing * (numberOfMatrices - 1))) /
      2;
    for (let matrixIndex = 0; matrixIndex < countOfNotDoable; matrixIndex++) {
      // Calculate the starting Y position for the current matrix
      const offsetY =
        startY + (cellHeight * 3 + padding * 2 + matrixSpacing) * matrixIndex;
      /* Last page right section start here */
      doc.setTextColor(222, 16, 26); // Black color for text
      doc.setFontSize(8);
      doc.setFont("helvetica", "bold"); // Set the font type and style to normal (regular)
      doc.text("NOK", startX - 100, offsetY + 2);

      doc.setTextColor(0);
      doc.text("T: Target", startX - 90, offsetY + 2);

      doc.setFillColor(
        notDoableResult[matrixIndex]["RGB"][0],
        notDoableResult[matrixIndex]["RGB"][1],
        notDoableResult[matrixIndex]["RGB"][2]
      ); // Add dynamic RGB color here
      doc.rect(startX - 75, offsetY - 1, 4.5, 4.5, "F");
      doc.setFont("helvetica", "normal");
      /* Dynamic name addition name logic here */
      let textOffset = 2;
      let matrixName = notDoableResult[matrixIndex]["name"]
        ? notDoableResult[matrixIndex]["name"].substring(0, 65)
        : "NA";
      let arrString = sliceString(matrixName, 32);
      //let arrString = sliceString('NEQUE-PORRO-QUISQUAM-EST-QUI-DOL NEQUE-PORRO-QUISQUAM-EST-QUI-DOL NEQUE-PORRO-QUISQUAM-EST-QUI-DOL', 32);
      arrString.forEach((element, index) => {
        doc.text(element.trim(), startX - 67, offsetY + textOffset);
        textOffset = textOffset + 3;
      });

      doc.text(
        `L*= ${notDoableResult[matrixIndex]["LAB"][0].toFixed(
          2
        )}   a*= ${notDoableResult[matrixIndex]["LAB"][1].toFixed(
          2
        )}   b*= ${notDoableResult[matrixIndex]["LAB"][2].toFixed(2)}`,
        startX - 90,
        offsetY + 7 + textOffset
      );
      doc.setFont("helvetica", "bold");
      doc.text("5: Nearest ", startX - 90, offsetY + 15 + textOffset);

      if (notDoableResult[matrixIndex]["LAB_of_9_colors"].length > 1) {
        doc.setFillColor(
          notDoableResult[matrixIndex]["RGB_of_9_colors"][4][0],
          notDoableResult[matrixIndex]["RGB_of_9_colors"][4][1],
          notDoableResult[matrixIndex]["RGB_of_9_colors"][4][2]
        ); // Add dynamic RGB color here
        doc.rect(startX - 73, offsetY + 12 + textOffset, 4.5, 4.5, "F");

        doc.setFont("helvetica", "normal");
        doc.text(
          `L*= ${notDoableResult[matrixIndex]["LAB_of_9_colors"][4][0].toFixed(
            2
          )}  a*= ${notDoableResult[matrixIndex][
            "LAB_of_9_colors"
          ][4][1].toFixed(2)}  b*= ${notDoableResult[matrixIndex][
            "LAB_of_9_colors"
          ][4][2].toFixed(2)}`,
          startX - 90,
          offsetY + 20 + textOffset
        );
        doc.text(
          `dL*= ${notDoableResult[matrixIndex]["delta_values"][
            "dL_star"
          ].toFixed(2)}  da*= ${notDoableResult[matrixIndex]["delta_values"][
            "da_star"
          ].toFixed(2)}  db*= ${notDoableResult[matrixIndex]["delta_values"][
            "db_star"
          ].toFixed(2)}  dE*= ${notDoableResult[matrixIndex]["delta_values"][
            "dE_star"
          ].toFixed(2)}`,
          startX - 90,
          offsetY + 25 + textOffset
        );

        /* Last page right section end here */
        // Draw the 3x3 matrix with different colors and add numbers or 'T'
        let cellNumber = 1;

        doc.setTextColor(0);
        doc.setFontSize(8);
        doc.text(`T:`, startX + 50, offsetY);
        doc.text(
          `L*= ${notDoableResult[matrixIndex]["LAB"][0].toFixed(2)}`,
          startX + 55,
          offsetY
        );
        doc.text(
          `a*= ${notDoableResult[matrixIndex]["LAB"][1].toFixed(2)}`,
          startX + 72,
          offsetY
        );
        doc.text(
          `b*= ${notDoableResult[matrixIndex]["LAB"][2].toFixed(2)}`,
          startX + 90,
          offsetY
        );

        /* Add the Right side dynamic content here */
        let counter = 1;
        let k = 0;
        for (let j = 0; j < 3; j++) {
          // Rows
          let z = offsetY + (cellHeight + padding) * j;
          for (let i = 0; i < 3; i++, k++) {
            // Columns
            const x = startX + (cellWidth + padding) * i;
            const y = offsetY + (cellHeight + padding) * j;
            doc.setTextColor(0); // White color for text
            doc.setFontSize(8);
            let spacer = z + 4.5;
            z = spacer;

            /* calculate DE* */
            let L1 = Number(notDoableResult[matrixIndex]["LAB"][0]);
            let L2 = Number(
              notDoableResult[matrixIndex]["LAB_of_9_colors"][k][0]
            );

            let a1 = Number(notDoableResult[matrixIndex]["LAB"][1].toFixed(2));
            let a2 = Number(
              notDoableResult[matrixIndex]["LAB_of_9_colors"][k][1]
            );

            let b1 = Number(notDoableResult[matrixIndex]["LAB"][2].toFixed(2));
            let b2 = Number(
              notDoableResult[matrixIndex]["LAB_of_9_colors"][k][2]
            );

            console.log(`Z = ${z}  z= ${i}  j=${j}    spacer=${spacer}`);
            doc.text(`${counter++}:`, startX + 50, spacer);
            doc.text(
              `L*= ${notDoableResult[matrixIndex]["LAB_of_9_colors"][
                k
              ][0].toFixed(2)}`,
              startX + 55,
              spacer
            );
            doc.text(
              `a*= ${notDoableResult[matrixIndex]["LAB_of_9_colors"][
                k
              ][1].toFixed(2)}`,
              startX + 72,
              spacer
            );
            doc.text(
              `b*= ${notDoableResult[matrixIndex]["LAB_of_9_colors"][
                k
              ][2].toFixed(2)}`,
              startX + 90,
              spacer
            );
            doc.text(
              `dE*= ${calculateDeltaE(L1, L2, a1, a2, b1, b2)}`,
              startX + 107,
              spacer
            );

            // Set color and draw the single rectangle in matrix
            doc.setFillColor(
              notDoableResult[matrixIndex]["RGB_of_9_colors"][k][0],
              notDoableResult[matrixIndex]["RGB_of_9_colors"][k][1],
              notDoableResult[matrixIndex]["RGB_of_9_colors"][k][2]
            ); // Add dynamic RGB color here
            doc.rect(x, y, cellWidth, cellHeight, "F"); // 'F' for filled rectangle
            /* Call helper function to detect the contrast color of each square */
            let contrastColor = getContrastColorFromRgb(
              notDoableResult[matrixIndex]["RGB"][0],
              notDoableResult[matrixIndex]["RGB"][1],
              notDoableResult[matrixIndex]["RGB"][2]
            );
            doc.setTextColor(contrastColor); // White color for text
            doc.setFont("helvetica", "normal"); // Set the font type and style to normal (regular)

            // Display the number or 'T' in the center of the cell
            if (cellNumber === 5) {
              console.log(x + cellWidth / 2);
              console.log(y + cellHeight / 2);
              doc.setFillColor(
                notDoableResult[matrixIndex]["RGB"][0],
                notDoableResult[matrixIndex]["RGB"][1],
                notDoableResult[matrixIndex]["RGB"][2]
              ); // Add dynamic RGB color here
              /* Add dynamic Square box for the Rectangle */
              doc.rect(
                x + cellWidth / 2 - 3,
                y + cellHeight / 2 - 3,
                6,
                6,
                "F"
              ); // 'F' for filled rectangle
              doc.text("T", x + cellWidth / 2, y + cellHeight / 2, {
                align: "center",
                baseline: "middle",
              });
              doc.text("5", x + cellWidth / 2 - 5, y + cellHeight / 2 + 5, {
                align: "right",
                baseline: "bottom",
              });
            } else {
              doc.text(
                cellNumber.toString(),
                x + cellWidth / 2,
                y + cellHeight / 2,
                { align: "center", baseline: "middle" }
              );
            }

            cellNumber++; // Increment cell number
          }
        }
      } else {
        const x = startX + (cellWidth + padding);
        const y = offsetY + (cellHeight + padding);
        doc.setFillColor(
          notDoableResult[matrixIndex]["RGB_of_9_colors"][0][0],
          notDoableResult[matrixIndex]["RGB_of_9_colors"][0][1],
          notDoableResult[matrixIndex]["RGB_of_9_colors"][0][2]
        ); // Add dynamic RGB color here
        doc.rect(startX - 73, offsetY + 12 + textOffset, 4.5, 4.5, "F");

        doc.setFont("helvetica", "normal");
        doc.text(
          `L*= ${notDoableResult[matrixIndex]["LAB_of_9_colors"][0][0].toFixed(
            2
          )}  a*= ${notDoableResult[matrixIndex][
            "LAB_of_9_colors"
          ][0][1].toFixed(2)}  b*= ${notDoableResult[matrixIndex][
            "LAB_of_9_colors"
          ][0][2].toFixed(2)}`,
          startX - 90,
          offsetY + 20 + textOffset
        );
        doc.text(
          `dL*= ${notDoableResult[matrixIndex]["delta_values"][
            "dL_star"
          ].toFixed(2)}  da*= ${notDoableResult[matrixIndex]["delta_values"][
            "da_star"
          ].toFixed(2)}  db*= ${notDoableResult[matrixIndex]["delta_values"][
            "db_star"
          ].toFixed(2)}  dE*= ${notDoableResult[matrixIndex]["delta_values"][
            "dE_star"
          ].toFixed(2)}`,
          startX - 90,
          offsetY + 25 + textOffset
        );

        doc.setFillColor("#FFFFFF");
        doc.rect(x, y - 7, 70, 12, "F");
        doc.rect(x, y - 7, 70, 12, "S");
        doc.setFont("helvetica", "italic");
        doc.text(
          "       Recycle resin gamut volume too small to \n       provide alternative colors",
          x,
          y - 2
        );
      }
    }
    await commonFooter(doc);
  };

  const resutlFooter = async (doc, countDetails) => {
    // Set font and size for the text
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    const boxHeight = 22; // Adjusted height to fit the bullet list
    const padding = 12;
    const boxYPosition = doc.internal.pageSize.height - boxHeight - 20; // 10 units from the bottom edge
    const boxWidth = doc.internal.pageSize.width - 2 * padding; // Adjust width to include padding

    // Set the color for the box (light grey)
    doc.setFillColor(224, 224, 224); // RGB for light grey

    // Draw the box
    doc.rect(10, boxYPosition, boxWidth, boxHeight); // 'F' for filling the rectangle
    // Add text inside the box
    doc.setTextColor(0, 0, 0); // set text color to black
    const bulletPoints = [
      "RESULT",
      `•  ${countDetails.achievableCount}/${countDetails.targetColorLen} dots are inside recycled resin gamut`,
      `•  ${countDetails.achievableCount}/${countDetails.targetColorLen} colors are achievable in ${countDetails.resinDetails}`,
    ];

    let textY = boxYPosition + 6; // Adjust Y position for the text inside the box

    // Add the bullet points inside the box
    bulletPoints.forEach((line, index) => {
      doc.setFillColor(224, 224, 224); // RGB for light grey
      if (index == 0) {
        doc.setFont("helvetica", "bold");
      } else {
        doc.setFont("helvetica", "normal");
      }
      doc.text(line, padding + 6, textY); // Add 5 units of padding from left
      textY += 6; // Increase Y position for the next line
    });
  };

  return (
    <div className="download-page-container">
      {isVisible && (
        <div>
          <div ref={plotRef1}></div>
          <div ref={plotRef2}></div>
          <div ref={plotRef3}></div>
          <div ref={plotRef4}></div>
        </div>
      )}

      {loading ? (
        <Loader message="" className="download-overlay" />
      ) : (
        <>
          <Button
            disabled={downloadBtnDisabled}
            sx={{
              mr: 1,
              width: "216px",
              height: "40px",
              padding: "8px 40px",
              borderRadius: "24px",
              border: "1px solid #385DAE",
              gap: "10px",
              background: downloadBtnDisabled
                ? "#F0F0F0"
                : "linear-gradient(90deg, #3A5DAE 0%, #4EC3E0 100%)",
              border: "1px solid",
              color: downloadBtnDisabled ? "#858585 !important" : "#FFFFFF",
              textTransform: "none",
              fontFamily: "Source Sans Pro",
              fontWeight: "600",
            }}
            onClick={generatePDF}
          >
            <img
              src={
                downloadBtnDisabled
                  ? DisabledDownloadReportIcon
                  : DownloadReportIcon
              }
              title="Download Report"
              alt="Download"
              style={{ width: "18px" }}
            />
            Download report
          </Button>
        </>
      )}
    </div>
  );
};

export default DownloadReport;
